import { Link } from 'react-router-dom';

export default function PageNotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4" dir="rtl">
      <div className="text-center space-y-4 max-w-md">
        <p className="text-6xl font-black text-primary">404</p>
        <h1 className="text-2xl font-bold text-foreground">الصفحة غير موجودة</h1>
        <p className="text-muted-foreground text-sm">
          الرابط الذي تحاول الوصول إليه غير موجود أو تم نقله.
        </p>
        <Link
          to="/"
          className="inline-block bg-primary text-white font-semibold rounded-xl px-6 py-2.5 hover:bg-primary/90 transition-colors"
        >
          العودة إلى الرئيسية
        </Link>
      </div>
    </div>
  );
}
